<template>
	<div>
		<customer-nav-header  :headerTitle="'Select a '  | headerTitleText" :customCSS='customCSS' />
		<b-tabs content-class="mt-3 mx-4">

			<b-tab title="Click & Collect Desk">
				<b-row v-if="weekOneData.length > 1">
					<b-col cols="6" class="border p-4"><strong>Week one - {{ weekOneDateRange }} - Click & Collect Calendar</strong><week-slots-grid :slots="weekOneData" :admin="false" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week two - {{ weekTwoDateRange }} - Click & Collect Calendar</strong><week-slots-grid :slots="weekTwoData" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>
				<b-row v-if="weekThreeData.length > 1">
					<b-col cols="6" class="border p-4"><strong>Week three - {{ weekThreeDateRange }} - Click & Collect Calendar</strong><week-slots-grid :slots="weekThreeData" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week four -  {{ weekFourDateRange }} - Click & Collect Calendar</strong><week-slots-grid :slots="weekFourData" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>
			</b-tab>
			<b-tab title="Click & Collect Locker">
				<b-row v-if="weekOneData.length > 1">
					<b-col cols="6" class="border p-4"><strong>Week one - {{ weekOneLockerDateRange }} - Locker Calendar</strong><week-slots-grid :slots="weekOneLockerData" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week two - {{ weekTwoLockerDateRange }} - Locker Calendar</strong><week-slots-grid :slots="weekTwoLockerData" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>
				<b-row v-if="weekThreeData.length > 1">
					<b-col cols="6" class="border p-4"><strong>Week three - {{ weekThreeLockerDateRange }} - Locker Calendar</strong><week-slots-grid :slots="weekThreeLockerData" @show-form-modal="showFormModal" class="pt-2"/></b-col>
					<b-col cols="6" class="border p-4"><strong>Week four -  {{ weekFourLockerDateRange }} - Locker Calendar</strong><week-slots-grid :slots="weekFourLockerData" @show-form-modal="showFormModal" class="pt-2"/></b-col>
				</b-row>			
			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
import CustomerNavHeader from './CustomerNavHeader'
import {RepositoryFactory} from '../api/RepositoryFactory'
import {mixin} from '../mixins/clickAndCollectMixins'
const SlotsRepoPost = RepositoryFactory.post('slots')
import WeekSlotsGrid from './WeekSlotsGrid'
export default{
	name: 'DesktopCustomerSlotCalendar',
	components: {WeekSlotsGrid, CustomerNavHeader},
	mixins: [mixin],
		data(){
			return{
				customCSS:{
					bgColor: '#AA090A',
					fontColor: '#fff'
				},
				weekOneDateRange : "",
				weekOneData: [],
				weekTwoDateRange : "",
				weekTwoData: [],				
				weekThreeDateRange : "",				
				weekThreeData: [],
				weekFourDateRange : "",				
				weekFourData: [],
				weekOneLockerDateRange : "",
				weekOneLockerData: [],
				weekTwoLockerDateRange : "",
				weekTwoLockerData: [],				
				weekThreeLockerDateRange : "",				
				weekThreeLockerData: [],
				weekFourLockerDateRange : "",				
				weekFourLockerData: [],
				form: {
					customerName: '',
					orderEmail: '',
					orderMobileNumber: '',
					orderId: '',
					slotId:	'',
					slotType: '',
					slotTime: ''
				},
				typeText: '',
				selectedSlotDay: '',
				selectedSlotDate: '',
				selectedSlotTime: '',
				selectedSlotId: '',
				selectedSlotType: '',
				fullPage: false,
				formSubmitted: false,
				boxTwo: ""
		}
	},
	created(){
		this.fetchGetLockerSlotsDesktop();
		this.fetchGetClickAndCollectSlotsDesktop();
	},
	methods:{
		async PostAddBooking(){
			var payload = new FormData();
			for ( var key in this.form ) {
				payload.append(key, this.form[key]);
			}	
			await SlotsRepoPost.postAddSlotBooking(payload)
		},
		showFormModal(event){
		console.log(event)
		this.typeText = (event.slotType === 'locker')? 'Locker Booking' : 'Click and Collect Booking'
		this.selectedSlotDay = event.slotDay
		this.selectedSlotDate = event.slotDate
		this.selectedSlotTime = event.slotTime
		this.selectedSlotType = event.slotType
		this.form.slotType = event.slotType
		this.form.slotDate = event.slotDate
		this.form.slotTime = event.slotTime
		this.form.slotId = event.slotId
		this.showCustomerSlotConfirmationModal()
		},	
	},
	computed:{

	},
	mounted(){
	
	}
}

</script>

<style>
.vld-icon {
    text-align: center
}
</style>
